module.exports = __webpack_public_path__ + "media/img/event/profiling-result-2-ea21474c0646da2c9087d1998bb78dd8.png";